import { IAccount } from 'store/accounts.model';
import { IApiResponse, ICustomer } from 'utils/models';

export interface IFormValues {
  sourceAccount: string;
  transferData: {
    netWork: string;
    beneficiaryWalletNumber: string;
    walletName: string;
    beneficiaryName: string;
    description: string;
    amount: number;
    eleveyFee: number;
    eleveyId: string;
    charge: number;
  }[];
}
export interface INetwork {
  name: string;
  code: string;
  gipCode: string;
}

export interface INetworksResponse extends IApiResponse {
  networks: INetwork[];
}

export interface IWalletBeneficiary {
  id: number;
  name: string;
  networkCode: string;
  beneficiaryWalletNumber: string;
  customer: ICustomer;
}

export interface IWalletBeneficiaryResponse extends IApiResponse {
  beneficiaries: IWalletBeneficiary[];
}

export interface IWalletState {
  accounts: IAccount[];
  networks: INetwork[];
  beneficiaries: IWalletBeneficiary[];
  selectedBeneficiary?: IWalletBeneficiary;
  isLookingUp?: boolean;
  lastLookedUpPhone?: string;
  lastLookedUpNetwork?: string;
  walletName?: string;
}

export interface IWalletBenResponse extends IApiResponse {
  accountName: string;
}

export type FindBenNameType = (index: number) => void;

export interface IMobileMoneyActions {
  findBeneficiaryName: (index: number) => void;
  handleElevyResponse: (index: number) => void;
}

export type IHandleFieldsChange = () => Promise<any>;
export interface IElevyState {
  charge: string;
  taxableAmount: string;
  eLevyId: string;
}

export interface IElevyResponse extends IApiResponse {
  charge: string;
  taxableAmount: string;
  eLevyId: string;
}

export const Warnings = {
  MAX_FIELD_ENTRY: "You've reached a maximum of 50 entries",
  BENEFICIARY_WALLET_NUMBER: 'Unable to verify recepient',
};

export interface IMobileMoneyResponse extends IApiResponse {
  transactionId: number;
}

export const bulkDataConfig = {
  sourceAccount: 'Source Account:',
  Numberoftransactions: 'Number of transactions:',
  PrincipalAmount: 'Principal Amount:',
  ELevyFee: 'ELevy Fee:',
  TransactionFee: 'Transaction Fee:',
  totalAmount: 'Total Amount:',
};

export const bulkSortArray = [
  'Source Account:',
  'Number of transactions:',
  'Principal Amount:',
  'ELevy Fee:',
  'Transaction Fee:',
  'Total Amount:',
];
export interface IChargeState {
  charge: number;
}
export interface IMobileMoneyChargeResponse extends IApiResponse {
  charge: number;
}
